//Import Css
import "bootstrap";
// import 'bootstrap/dist/css/bootstrap.css'
import "bootstrap-vue/dist/bootstrap-vue.css";
import "flag-icon-css/css/flag-icon.min.css";
import "flatpickr/dist/flatpickr.css";

//import css
import "@/assets/default/app.min.css";
// import '@/assets/default/style-responsive.min.css'
// import '@/assets/default/theme/red.min.css'
// import '@/assets/default/style.css'

// import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'

// import fonts
import "@/assets/fonts/fonts.css";

// import fontawesome
import "@/assets/fontawesome/all.min.css";

// import mixins
import mixinMethods from "@/assets/mixin/methods.js";

import Vue from "vue";
import App from "./App.vue";

//for older browser compatibility
import "es6-promise";

import VueX from "vuex";

//routes
import router from "./Options/router.js";

//store
import storeOptions from "./store/store.js";

//axios
import Axios from "axios";
Axios.defaults.baseURL = env.urlStart;

// const urlStart = Axios.create({
//   baseURL: env.urlStart,
// });
const urlSSO = Axios.create({
  baseURL: env.urlSSO,
});

// Vue.prototype.$http = urlStart;
Vue.prototype.$http = Axios; // to run axios, just use this.$http
Vue.prototype.$httpSSO = urlSSO;

//vue bootstrap
import VueBootstrap from "bootstrap-vue";

//vuetify
// const Vuetify = () => import('vuetify')

//VueInsProgress
import VueInsProgressBar from "vue-ins-progress-bar";

//import SweetAlert
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

//import vue meta
import VueMeta from "vue-meta";

//import env
import env from "./env.js";

//add panel for global use
import VuePanel from "./plugins/panel/";

import vueUniversalTable from "@/components/table/vue_universal_table.vue";
import vueUserManagementTable from "@/components/table/vue_user_management_table.vue";
import vueReportSuspectTable from "@/components/table/vue_report_suspect_table.vue";
import MultiSelect from "vue-multiselect";
import flatPickr from "vue-flatpickr-component";
import VueHtmlToPaper from "vue-html-to-paper";
import VueNativeNotification from "vue-native-notification";

import VueSignaturePad from "vue-signature-pad";

Vue.use(VueSignaturePad);

const vueHtmlToPaperOptions = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css",
  ],
};

//Socket IO (uncomment to use)
// import VueSocketIOExt from 'vue-socket.io-extended';
// import io from 'socket.io-client';
// const socket = io(env.urlStart);
// Vue.use(VueSocketIOExt, socket);

Vue.use(VueX);
Vue.use(VueBootstrap);
Vue.use(VueInsProgressBar, {
  position: "fixed",
  show: true,
  height: "3px",
});
Vue.use(VueNativeNotification, {
  // Automatic permission request before
  // showing notification (default: true)
  requestOnNotify: true,
});
Vue.filter("terbilang", function (value) {
  function terbilang(a) {
    var c =
      " Satu Dua Tiga Empat Lima Enam Tujuh Delapan Sembilan Sepuluh Sebelas".split(
        " "
      );
    if (12 > a) var b = c[a];
    else
      20 > a
        ? (b = c[a - 10] + " Belas")
        : 100 > a
        ? ((b = parseInt(String(a / 10).substr(0, 1))),
          (b = c[b] + " Puluh " + c[a % 10]))
        : 200 > a
        ? (b = "Seratus " + terbilang(a - 100))
        : 1e3 > a
        ? ((b = parseInt(String(a / 100).substr(0, 1))),
          (b = c[b] + " Ratus " + terbilang(a % 100)))
        : 2e3 > a
        ? (b = "Seribu " + terbilang(a - 1e3))
        : 1e4 > a
        ? ((b = parseInt(String(a / 1e3).substr(0, 1))),
          (b = c[b] + " Ribu " + terbilang(a % 1e3)))
        : 1e5 > a
        ? ((b = parseInt(String(a / 100).substr(0, 2))),
          (a %= 1e3),
          (b = terbilang(b) + " Ribu " + terbilang(a)))
        : 1e6 > a
        ? ((b = parseInt(String(a / 1e3).substr(0, 3))),
          (a %= 1e3),
          (b = terbilang(b) + " Ribu " + terbilang(a)))
        : 1e8 > a
        ? ((b = parseInt(String(a / 1e6).substr(0, 4))),
          (a %= 1e6),
          (b = terbilang(b) + " Juta " + terbilang(a)))
        : 1e9 > a
        ? ((b = parseInt(String(a / 1e6).substr(0, 4))),
          (a %= 1e6),
          (b = terbilang(b) + " Juta " + terbilang(a)))
        : 1e10 > a
        ? ((b = parseInt(String(a / 1e9).substr(0, 1))),
          (a %= 1e9),
          (b = terbilang(b) + " Milyar " + terbilang(a)))
        : 1e11 > a
        ? ((b = parseInt(String(a / 1e9).substr(0, 2))),
          (a %= 1e9),
          (b = terbilang(b) + " Milyar " + terbilang(a)))
        : 1e12 > a
        ? ((b = parseInt(String(a / 1e9).substr(0, 3))),
          (a %= 1e9),
          (b = terbilang(b) + " Milyar " + terbilang(a)))
        : 1e13 > a
        ? ((b = parseInt(String(a / 1e10).substr(0, 1))),
          (a %= 1e10),
          (b = terbilang(b) + " Triliun " + terbilang(a)))
        : 1e14 > a
        ? ((b = parseInt(String(a / 1e12).substr(0, 2))),
          (a %= 1e12),
          (b = terbilang(b) + " Triliun " + terbilang(a)))
        : 1e15 > a
        ? ((b = parseInt(String(a / 1e12).substr(0, 3))),
          (a %= 1e12),
          (b = terbilang(b) + " Triliun " + terbilang(a)))
        : 1e16 > a &&
          ((b = parseInt(String(a / 1e15).substr(0, 1))),
          (a %= 1e15),
          (b = terbilang(b) + " Kuadriliun " + terbilang(a)));
    a = b.split(" ");
    c = [];
    for (b = 0; b < a.length; b++) "" != a[b] && c.push(a[b]);
    return c.join(" ");
  }
  return terbilang(value);
});
Vue.use(VueSweetalert2);
Vue.use(VuePanel);
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true,
});
// Vue.use(VueHtmlToPaper);
Vue.use(VueHtmlToPaper, vueHtmlToPaperOptions);

Vue.component("vue-universal-table", vueUniversalTable);
Vue.component("vue-user-management-table", vueUserManagementTable);
Vue.component("vue-report-suspect-table", vueReportSuspectTable);
Vue.component("flat-pickr", flatPickr);
Vue.component("MultiSelect", MultiSelect);

Vue.mixin({
  methods: mixinMethods,
});

//import GMaps
import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    key: env.VUE_APP_GOOGLE_MAPS_API_KEY_DOMAIN_DETECTION,
    libraries: "places",
  },
});

Vue.config.productionTip = env.productionMode;

const store = new VueX.Store(storeOptions);

router.beforeEach((to, from, next) => {
  if (to.meta.menu && to.meta.module && store.state.userData) {
    let user = store.state.userData.userData;
    // console.log(user)
    Axios.defaults.headers.common["Authorization"] = "Bearer " + user.token;

    Axios.post("/api/settings/post-activity", {
      menu: to.meta.menu,
      module: to.meta.module,
    })
      .then((resp) => {
        console.log("response has been recorded");
      })
      .catch((err) => {
        console.log(err);
      });
  }
  next();
});

//inject Vue to Id = App
new Vue({
  el: "#app",
  store,
  router: router,
  render: (h) => h(App),
});

function logout() {
  //delete token
}
